const WORKFLOW_PHASE_LABELS = {
    lead_intake: 'Erstgespräch',
    screening_required: 'Erstscreening',
    audit_required: 'Projektaudit',
    program_required: 'Programmauswahl',
    audit_score_required: 'Audit-Score',
    application_strategy_required: 'Schreibstrategie',
    draft_required: 'Antragsentwurf',
    questionnaire_required: 'Fragebogen',
    portal_required: 'Kundenportal',
    customer_input_required: 'Kundeninput',
    planning_required: 'Projektplanung',
    description_required: 'Vorhabensbeschreibung',
    internal_review_required: 'Interne Prüfung',
    customer_review_required: 'Kundenfreigabe',
    final_export_required: 'Finalexport',
    application_package_ready: 'Antragspaket bereit',
    submission_monitoring: 'Begutachtung',
    award_acceptance: 'Bewilligung',
    billing_readiness: 'Abrechnung',
    commercial_close: 'Projektabschluss',
    unknown: 'Workflow prüfen'
};

const WORKFLOW_VALUE_LABELS = {
    missing: 'Fehlt',
    done: 'Erledigt',
    done_inferred: 'Durch Folge-Gate erfüllt',
    selected: 'Ausgewählt',
    open: 'Offen',
    weak: 'Schwach',
    usable: 'Nutzbar',
    strong: 'Stark',
    final: 'Final',
    partial: 'Teilweise',
    prepared: 'Vorbereitet',
    needs_score: 'Score fehlt',
    needs_screening: 'Screening fehlt',
    draft: 'Entwurf',
    internally_reviewed: 'Intern geprüft',
    customer_reviewed: 'Kundengeprüft',
    ready: 'Bereit',
    not_ready: 'Nicht bereit',
    high: 'Hoch',
    medium: 'Mittel',
    low: 'Niedrig',
    active: 'Aktiv',
    sent: 'Gesendet',
    gesendet: 'Gesendet',
    aktiv: 'Aktiv',
    ausgefüllt: 'Ausgefüllt',
    ausgefuellt: 'Ausgefüllt',
    geschlossen: 'Geschlossen',
    mittel: 'Mittel',
    hoch: 'Hoch',
    niedrig: 'Niedrig'
};

const fallbackLabel = (value, fallback = 'Offen') => {
    const text = String(value || '').trim();
    if (!text) return fallback;
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const formatWorkflowPhase = (value) => {
    const normalized = String(value || '').trim();
    return WORKFLOW_PHASE_LABELS[normalized] || fallbackLabel(normalized, 'Workflow offen');
};

export const formatWorkflowValue = (value, fallback = 'Offen') => {
    const normalized = String(value || '').trim().toLowerCase();
    return WORKFLOW_VALUE_LABELS[normalized] || fallbackLabel(value, fallback);
};

export const formatWorkflowCoreVersion = (value) => {
    if (value === 'workflow-core-v1') return 'Core v1';
    return fallbackLabel(value, 'Core');
};
